import { InnerProductUnits, IQuantity } from '@ellure/types';
import { CustomizationAttribute } from './production-order';

export enum ProductionRequestStatusEnum {
  PENDING = 'pending',
  IN_PRODUCTION = 'in-production',
  COMPLETED = 'completed',
  CANCELLED = 'cancelled',
  ERROR = 'error',
  DELETED = 'deleted',
}

export const ProductionRequestStatusColorMap: Record<ProductionRequestStatusEnum, string> = {
  'in-production': 'yellow',
  cancelled: 'red',
  error: 'red',
  completed: 'green',
  deleted: 'gray',
  pending: 'gray',
};

export type Formulation<ExtraProps = {}> = Record<
  string,
  IQuantity<InnerProductUnits> &
    ExtraProps & {
      label: string;
    }
>;

export type ExpectedProductSpecifications = {
  weight: number;
  formulation: Formulation;
};

export type ActualProductSpecifications = {
  weight: number;
  formulation: Formulation<{ batchId: string }>;
};

export type ProductionRequest = {
  id: string;
  template: {
    id: string;
    label: string;
  };
  expected: ExpectedProductSpecifications;
  customizationAttributes?: Record<string, CustomizationAttribute>;
  createdAt: string;
  updatedAt: string;
} & (
  | {
      status: ProductionRequestStatusEnum.PENDING | ProductionRequestStatusEnum.DELETED | ProductionRequestStatusEnum.IN_PRODUCTION;
    }
  | {
      status: ProductionRequestStatusEnum.CANCELLED;
      cancelReason: string;
    }
  | {
      status: ProductionRequestStatusEnum.ERROR;
      errorReason: string;
    }
  | {
      status: ProductionRequestStatusEnum.COMPLETED;
      actual: ActualProductSpecifications;
    }
);
